import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "index",
    component: () => import("../views/index.vue"),
    children: [
        {
            path: "/home",
            name: "home",
            component: () => import("../views/home/home.vue"),
          },
        {
            path: "/about",
            name: "about",
            component: () => import("../views/about/about.vue"),
          },
          {
            path: "/case",
            name: "case",
            component: () => import("../views/case/case.vue"),
          },
          {
            path: "/product",
            name: "product",
            component: () => import("../views/product/product.vue"),
          },
          {
            path: "/system",
            name: "system",
            component: () => import("../views/system/system.vue"),
          },
    ]
  },
  
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

router.afterEach((to, from, next) => {
    window.scrollTo(0, 0)
  });


//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router;
